(() => {
  const init = scope => {
    const hubs = [...scope.querySelectorAll('[data-faq-hub]')];
    if (scope.matches?.('[data-faq-hub]')) hubs.unshift(scope);
    hubs.forEach(hub => {
      if (hub.dataset.faqInitialized) return;
      const switcher = hub.querySelector('[data-faq-switch]');
      const tabs = [...hub.querySelectorAll('[data-faq-tab]')];
      const panels = [...hub.querySelectorAll('[data-faq-panel]')];
      if (!switcher || !tabs.length || panels.length !== tabs.length) return;
      hub.dataset.faqInitialized = 'true';
      switcher.setAttribute('role', 'tablist');
      tabs.forEach(tab => tab.setAttribute('role', 'tab'));
      panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      const select = (tab, focus = false) => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.faqPanel !== tab.dataset.faqTab;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(tabs[next], true);
        });
      });
      hub.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-faq-panel]');
        const tab = tabs.find(item => item.dataset.faqTab === panel?.dataset.faqPanel);
        if (tab) select(tab);
        const details = event.target.closest('details');
        if (details) details.open = true;
      });
      select(tabs[0]);
      hub.classList.add('is-enhanced');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
